import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pinned-wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "pinned-card"
}
const _hoisted_3 = { class: "pinned-index" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { style: {"flex":"1","max-width":"95%"} }
const _hoisted_6 = { class: "pinned-top" }
const _hoisted_7 = { class: "pinned-title" }
const _hoisted_8 = {
  key: 1,
  class: "pin-icon"
}
const _hoisted_9 = { class: "pinned-subtitle scrollable" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_ctx.pinnedMessages.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.activeMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pinnedMessages, (msg, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: msg.id,
                    class: _normalizeClass(["index-item", { active: index === _ctx.activeIndex }]),
                    onClick: ($event: any) => (_ctx.setActive(index))
                  }, null, 10, _hoisted_4))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.activeMessage.title), 1),
                  (_ctx.editable)
                    ? (_openBlock(), _createBlock(_component_Tooltip, {
                        key: 0,
                        text: "Unpin"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleUnpin && _ctx.handleUnpin(...args)), ["stop"])),
                            class: "pin-icon"
                          }, "📌")
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, "📌"))
                ]),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.activeMessage.content), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}